import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function Degen() {
  return (
    <div>
      <h1>Degenerate Things</h1>
      <Container>
        <Row className="g-0">
          <Col className="mb-3 g-0">
            {/* <a
              href="https://info.uniswap.org/#/pools/0xb98ce24b71d9e3355c516fb16d8f3cd5d0919d1f"
              target="_blank"
              rel="noopener noreferrer"
            >
              $TWIG Liquidity Pool
            </a> */}
          </Col>
        </Row>
        <Row>
          <Col>
            {/* <a
              href="https://discord.gg/tqtFrS2mQW"
              target="_blank"
              rel="noopener noreferrer"
            >
              Hoot Degens Discord
            </a>
            <p className="caption">
              discussions on $TWIGs, etc
              <br />
              NO Devs Allowed!
            </p> */}
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Degen;
